/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { useAppDispatch } from 'app/hooks';
import {
  checkEnableParseJSON,
  paserSubjectFirst,
  checkEmptyValue,
  checkSubjectMap,
  checkNoCreditAwarded,
  checkNoCreditEligible,
  getPointYearFromSchedule,
  checkNoCreditGradeCollege,
  checkThreeTrimester,
  checkTypeOfClassDualEnrollment,
} from 'components/helper/helper';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import LoadingContent from 'components/LoadingContent';
import Grid from '@mui/joy/Grid';
import { agSubjectTotals } from 'screen/counselor/components/RPersonalInformation';
import { mapAGSumaryCalculation } from 'screen/common/helper/fixValuesOnLoad';
import courseServices from 'services/courseServices';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import { getAccessToken, getUserId } from 'utils/sessionStorage';
import { removeAccessToken, removeUserId } from 'utils/sessionStorage';

interface Props {}

const AG_Summary = (props: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();  
  let studentId = getUserId();
  let token = getAccessToken();
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [myAGSummary, setMyAGSummary] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);

  const conditionGradeTH = (item: any, schedule: any, gradeScale: any) => {
    if (!item) return 0;

    const finalGrade = item.finalGrade;
    const finalCredit = item.finalCredits;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (gradeScale === '1-100') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grade ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (gradeScale === '1-100') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const selectOneSemester = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditAwarded(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectOneSemesterEligible = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditEligible(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionCollegeCourses = (item: any, scheduleSystem: string) => {
    if (
      !item ||
      item?.honorStatus !== 'CL' ||
      item?.transferable !== true ||
      item?.completionStatus === 'Select' ||
      checkEmptyValue(item?.grade) ||
      checkNoCreditGradeCollege(item?.grade)
    ) {
      return 0;
    }
    //Old logic : tính điểm của College course mà kg phải Dual Enrollment là phụ thuộc vào field Schedule System trên page College Course (O.5 hoặc 0.3)
    // const pointYear = getPointYearFromSchedule(scheduleSystem);
    //New logic : College course luôn luôn tính là 1 nếu Type of Class khác Dual Enrollment
    const pointYear = 1;
    return pointYear;
  };

  //For Grade Scale A-F
  const selectTwoSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  //For Grade Scale 1-100
  const selectTwoSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectThreeSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 3; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      if (checkThreeTrimester(point) === true) {
        point = 1; // Tránh trường hợp điểm bị làm tròn xuống 0.999
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };
  const selectThreeSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 3; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      if (checkThreeTrimester(point) === true) {
        point = 1; // Tránh trường hợp điểm bị làm tròn xuống 0.999
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectFourSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 4; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectFourSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 4; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionGeneralInfo = (item: any) => {
    if (
      !item ||
      checkEmptyValue(item?.type_of_class) ||
      checkEmptyValue(item?.is_weighted_course)
    ) {
      return 0;
    }

    const schedule = item.schedule; // Lưu giá trị schedule để dùng lại
    const finalGrade = item.final_grade;
    const finalCredit = item.final_credit;
    const gradeScale = item.grade_scale;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (gradeScale === '1-100') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grades ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === false &&
          item.isFourthSemester === false
        ) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === false
        ) {
          return selectThreeSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === true
        ) {
          return selectFourSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (gradeScale === '1-100') {
        if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === false &&
          item.isFourthSemester === false
        ) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === false
        ) {
          return selectThreeSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === true
        ) {
          return selectFourSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };  

  const handleContinue = () => {
    history.push(routers.wCourseSummary.path);
  };

  const getData = async () => {
    studentId = getUserId();
    token = getAccessToken();
    try {
      if (token && studentId) {
        setLoading(true);
        const res: any = await caculatorSubjectYears(studentId);
        setMyAGSummary(res);
        setLoading(false);
      }
      else {
      handleLogout();
    }
    } catch (ex) {
      console.log('Error: ', ex);
    }

  };
  const caculatorSubjectYears = async (studentId: any) => {
    let countKeys = {
      A: 0,
      B: 0,
      C: 0,
      D1: 0,
      D2: 0,
      E: 0,
      F: 0,
      G: 0,
    };
    const resGradeAndCourse: any = await courseServices.getGradeAndCourse(studentId);
    const resGeneral: any = await courseServices.getGeneral(studentId);

    const summary9th = checkEnableParseJSON(resGradeAndCourse?.grade_9_course_array, []);
    const summary10th = checkEnableParseJSON(resGradeAndCourse?.grade_10_course_array, []);
    const summary11th = checkEnableParseJSON(resGradeAndCourse?.grade_11_course_array, []);
    const summary12th = checkEnableParseJSON(resGradeAndCourse?.grade_12_course_array, []);

    const summaryTH = [...summary9th, ...summary10th, ...summary11th, ...summary12th];
    const summaryCollegeCourses = checkEnableParseJSON(
      resGradeAndCourse?.college_course_array,
      []
    );
    const additional_info = checkEnableParseJSON(resGeneral?.additional_info, {});
    let listCollegeCourses: string[] = [];

    if (summaryTH && summaryTH.length>0) {
      (summaryTH ?? []).map((item: any) => {
        mapAGSumaryCalculation(item);
        item?.subjectDetails?.map((subject: any) => {
          if (
            checkTypeOfClassDualEnrollment(subject?.typeOfClass, subject?.isTakeClassAtCollege) ===
            true
          ) {
            listCollegeCourses.push(subject?.collegeTookClass);
          }
          const pointYear = conditionGradeTH(subject, item?.schedule, item?.CMGradingScale);
          if (!checkEmptyValue(pointYear)) {
            let agSubjectArea = subject?.AGSubjectArea;
            const firstLetter = paserSubjectFirst(agSubjectArea).startLetter;
            let currentValue = (countKeys as any)[firstLetter];
            (countKeys as any)[firstLetter] = currentValue + pointYear;
          }
        });
      });
    }

    if (summaryCollegeCourses && summaryCollegeCourses.length>0) {
      (summaryCollegeCourses ?? []).map((item: any) => {
        const collegeName = item?.collegeName ?? '';
        const isExist:any[] = 
        (listCollegeCourses && listCollegeCourses.length>0) ? 
          listCollegeCourses.filter((name: string) => 
            name && name.includes(collegeName)):[]; // Kiểm tra collegeName đã có trong listCollegeCourses chưa
        
        if (isExist.length === 0) {
          item?.collegeCourseArray?.map((subject: any) => {
            const scheduleSystem = item?.scheduleSystem ?? '';
            const pointYear = conditionCollegeCourses(subject, scheduleSystem);
            if (!checkEmptyValue(pointYear)) {
              const subjectAreaValue = subject?.subject;
              const keyMap = checkSubjectMap(subjectAreaValue);
              if (keyMap != null) {
                let currentValue = (countKeys as any)[keyMap];
                (countKeys as any)[keyMap] = currentValue + pointYear;
              }
            }
          });
        }
      });
    }

    if (additional_info && additional_info.course_work && additional_info.course_work.length>0) {
      (additional_info?.course_work ?? []).map((item: any) => {
        const pointYear = conditionGeneralInfo(item);
        if (!checkEmptyValue(pointYear)) {
          const agSubjectArea = item?.ag_subject_requirement;
          const firstLetter = paserSubjectFirst(agSubjectArea).startLetter;
          let currentValue = (countKeys as any)[firstLetter];
          (countKeys as any)[firstLetter] = currentValue + pointYear;
        }
      });
    }


    return countKeys;
  };
  React.useEffect(() => {
    getData();
    caculatorSubjectYears(studentId);
  }, []);
  
  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
   return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'A-G Subject Summary' },
          { percentOnProcess: 80, title: 'Continue' },
        ]}
        title="A-G Summary"
        process={1}
        icon={<EventNoteOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form 
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }} 
            className="gm-form-grid"
          >
            
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className="gm-summary-container">
                  <div className="gm-summary-section">
                    <div className="gm-summary-section-title">A-G Subject Summary</div>
                    <div className="gm-summary-field-grid">
                      {Object.entries(agSubjectTotals).map(([key, value]) => (
                        <div key={key} className="gm-summary-field-item">
                          <div className="gm-summary-field-label">
                            <span className={'subject ' + key}>{key}</span>
                            <span className="subject-text"> {value}</span>
                          </div>
                          <div className="gm-summary-field-value">{myAGSummary?.[key] || '0'}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>

            <div className="row my-3 pt-3 mt-4 border-top">
              <div className="col-md-12">
                <div className="text-start text-md-end">
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>

    </>
  );
};

export default AG_Summary;
